<script setup lang="ts">
import { computed } from "vue";

import type { ClausensGender } from "./types";

const props = defineProps<{
  gender: ClausensGender;
}>();

const genderShortMap: Record<ClausensGender, string> = {
  femininum: "f",
  maskulinum: "m",
  neutrum: "n",
  pluralis: "pl"
};

const genderLongMap: Record<ClausensGender, string> = {
  femininum: "femininum (hunkøn)",
  maskulinum: "maskulinum (hankøn)",
  neutrum: "neutrum (intetkøn)",
  pluralis: "pluralis (flertal)"
};

const shortGender = computed<string>(() => {
  const mapped = genderShortMap[props.gender];

  if (!mapped) {
    return props.gender;
  }

  return mapped;
});

const longGender = computed<string>(() => {
  const mapped = genderLongMap[props.gender];

  if (!mapped) {
    return "";
  }

  return mapped;
});
</script>

<template>
  <sub :title="longGender">{{ shortGender }}</sub>
</template>
